module.exports = __webpack_public_path__ + "img/handraw_téléphone - footer copie.0661cef2.svg";